class AnimatedPlaceholder {
  constructor(inputElement) {
    this.input = inputElement;
    this.placeholders = this.getPlacements();
    this.currentIndex = 0;
    this.isTyping = true;
    this.charIndex = 0;
    this.typingSpeed = 100;
    this.deletingSpeed = 50;
    this.pauseTime = 2000;
    
    if (this.placeholders.length > 0) {
      this.startAnimation();
    }
  }

  getPlacements() {
    const placeholdersAttr = this.input.getAttribute('data-placeholders');
    if (!placeholdersAttr) return [];
    return placeholdersAttr.split('|').filter(p => p.trim());
  }

  startAnimation() {
    this.animate();
  }

  animate() {
    const currentPlaceholder = this.placeholders[this.currentIndex];
    
    if (this.isTyping) {
      if (this.charIndex < currentPlaceholder.length) {
        this.input.setAttribute('placeholder', currentPlaceholder.substring(0, this.charIndex + 1));
        this.charIndex++;
        setTimeout(() => this.animate(), this.typingSpeed);
      } else {
        // Finished typing, pause before deleting
        setTimeout(() => {
          this.isTyping = false;
          this.animate();
        }, this.pauseTime);
      }
    } else {
      if (this.charIndex > 0) {
        this.charIndex--;
        this.input.setAttribute('placeholder', currentPlaceholder.substring(0, this.charIndex));
        setTimeout(() => this.animate(), this.deletingSpeed);
      } else {
        // Finished deleting, move to next placeholder
        this.currentIndex = (this.currentIndex + 1) % this.placeholders.length;
        this.isTyping = true;
        setTimeout(() => this.animate(), 500);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const searchInputs = document.querySelectorAll('.search__input[data-placeholders]');
  searchInputs.forEach(input => {
    new AnimatedPlaceholder(input);
  });
});
